import React, { useEffect, useRef, useState, useContext } from 'react'
import "./navbar.scss"
import { NavLink, Link, useLocation } from 'react-router-dom'
import { AuthContext } from "../../context/auth.js"
import { toAbsoluteUrl } from '../../utils/assetHelper'
import { checkIsActive } from '../../utils/routeHelper'
import Logo from '../../assets/v1/logo.png'


export const Navbar = () => {
  const { setSignInModal, setSignUpModal, user, isLoggedIn, setLogOutModal, width, cartData } = useContext(AuthContext)
  const { pathname } = useLocation()
  const dropdownRef = useRef(null)
  const toolsDropdownRef = useRef(null)
  const technologiesDropdownRef = useRef(null)
  const moreDropdownRef = useRef(null)
  const [dropdownOpen, setDropDownOpen] = useState({ name: '', open: false })
  const [hamburgerOpen, setHamburgerOpen] = useState(false)
  const [quantity, setQuantity] = useState(1)

  useEffect(() => {
    if (cartData && cartData?.items?.length > 0) {
      setQuantity(cartData?.items?.reduce((acc, curr) => acc + curr?.quantity, 0))
    }
  }, [cartData])


  useEffect(() => {
    if (hamburgerOpen && width < 1360) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [hamburgerOpen, width])


  useEffect(() => {
    if (width > 1200) {
      const handleClickOutside = (event) => {
        if (
          (dropdownOpen.name === 'product' &&
            toolsDropdownRef.current &&
            !toolsDropdownRef.current.contains(event.target)) ||
          (dropdownOpen.name === 'technologies' &&
            technologiesDropdownRef.current &&
            !technologiesDropdownRef.current.contains(event.target)) ||
          (dropdownOpen.name === 'more' &&
            moreDropdownRef.current &&
            !moreDropdownRef.current.contains(event.target)) ||
          (dropdownOpen.name === 'profile' &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target))
        ) {
          setDropDownOpen({ name: '', open: false });
        }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [width, dropdownOpen]);


  return (
    <header id="nav-menu" aria-label="navigation bar">
      <div class="nav-container" style={{ boxShadow: pathname.includes('ssb') || pathname.includes('dsb-hr') || pathname.includes('dsb-nh') ? 'none' : '' }}>
        <div class="nav-start">
          {width < 1360 && 
          <Link class="logo" to="/v1">
            <img src={Logo} width="156" alt="Inc Logo" />
          </Link>
          }
          <nav class={`menu ${hamburgerOpen ? 'show' : ''}`}>
            <ul class="menu-bar">
              <li><NavLink className="nav-link" to="/v1/home">Home</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/product-search">Product Search</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/nir">NIR Products</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/service">Services</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/manufacturing">Manufacturing</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/product-release">New Products</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/stepdown">Stepdown</NavLink></li>
              <li><NavLink className="nav-link" to="/v1/platforms">Technologies</NavLink></li>
              <li>
                <button class="nav-link dropdown-btn" style={{ color: pathname.includes('product/') && !pathname.includes('product-search') ? 'var(--blueColor)' : '', fontWeight: dropdownOpen.name === 'product' && dropdownOpen.open ? '700' : '500' }} data-dropdown="dropdown1" aria-haspopup="true" aria-expanded="false" aria-label="product"
                  onClick={() => {
                    if (dropdownOpen.name === 'product') {
                      setDropDownOpen({
                        name: '',
                        open: false
                      })
                    } else {
                      setDropDownOpen({
                        name: 'product',
                        open: true
                      })
                    }
                  }}
                >
                  Tools
                  {dropdownOpen.name === 'product' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
                </button>
                <div id="dropdown1" className={`dropdown ${dropdownOpen.name === 'product' && dropdownOpen.open ? 'active' : ''}`} ref={toolsDropdownRef} style={{ right: 0 }}>
                  <ul role="menu">
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/v1/product/pathways">Interactive Molecular Pathways</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/v1/product/alexa-fluor-secondary">Identifyn® SRM Alexa Fluor™ Secondary Flourescence</NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              {width < 1360 && user && isLoggedIn && <li><NavLink className="nav-link cart-btn" to={"/v1/cart"}>
                Cart
                <i class="bx bx-cart" aria-hidden="true" style={{ fontSize: '24px', color: '#fff' }}></i>
                {cartData?.items && cartData?.items?.length > 0 && <span>{quantity}</span>}
              </NavLink>
              </li>
              }
              <div className="auth-container">
                {user && isLoggedIn ?
                  <>
                    <div class="nav-link avatar" style={{ color: pathname.includes('profile') ? 'var(--blueColor)' : '', cursor: 'pointer' }} data-dropdown="dropdown1" aria-haspopup="true" aria-expanded="false" aria-label="product"
                      onClick={() => {
                        if (dropdownOpen.name === 'profile') {
                          setDropDownOpen({
                            name: '',
                            open: false
                          })
                        } else {
                          setDropDownOpen({
                            name: 'profile',
                            open: true
                          })
                        }
                      }}
                    >
                      {user?.customer?.avatar ?
                        <img src={user?.customer?.avatar} alt="product" className='avatar-img' style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '2px solid var(--blueColor)' }} />
                        :
                        <div className="custom-profile" style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '1px solid #294156' }}>{user?.customer?.first_name[0]?.toUpperCase()}</div>
                      }
                      <span className='avatar-name'>{user?.customer?.first_name} {user.customer?.last_name}</span>
                      {dropdownOpen.name === 'profile' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
                    </div>
                    <div id="dropdown3" className={`dropdown ${dropdownOpen.name === 'profile' && dropdownOpen.open ? 'active' : ''}`} ref={dropdownRef}>
                      <ul role="menu ">
                        <li role="menuitem">
                          <NavLink class="dropdown-link" to="/v1/profile/account">Account</NavLink>
                        </li>
                        <li role="menuitem">
                          <NavLink className="dropdown-link" to="/v1/profile/orders">Orders</NavLink>
                        </li>
                        <li role="menuitem">
                          <Link class="dropdown-link" to="/v1/contact?support=Accout Support">Support</Link>
                        </li>
                        <li role="menuitem">
                          <button class="dropdown-link" style={{ fontSize: '1rem', color: 'var(--blueColor)' }} onClick={() => setLogOutModal(true)} >Sign Out</button>
                        </li>
                      </ul>
                    </div>
                  </>
                  : <>
                    <Link class="nav-link cart-btn" to={"/v1/cart"}>
                      Cart
                      <i class="fal fa-shopping-cart" aria-hidden="true" style={{ fontSize: '20px', color: '#fff' }}></i>
                      {cartData?.items && cartData?.items?.length > 0 && <span>{quantity}</span>}
                    </Link>
                    <button class="btn btn-transparent" style={{ marginBottom: '10px' }} onClick={() => setSignInModal(true)}>Sign In</button>
                    <button class="btn btn-primary" onClick={() => setSignUpModal(true)}>Sign Up</button>
                  </>
                }
              </div>
            </ul>
          </nav>
        </div>

        <div class="nav-end">
          <div class="right-container">
            {user && isLoggedIn ? <>
              <div class="nav-link avatar" style={{ color: pathname.includes('profile') ? 'var(--blueColor)' : '', cursor: 'pointer' }} data-dropdown="dropdown1" aria-haspopup="true" aria-expanded="false" aria-label="product"
                onClick={() => {
                  if (dropdownOpen.name === 'profile') {
                    setDropDownOpen({
                      name: '',
                      open: false
                    })
                  } else {
                    setDropDownOpen({
                      name: 'profile',
                      open: true
                    })
                  }
                }}
              >
                {user?.customer?.avatar ?
                  <img src={user?.customer?.avatar} alt="product" className='avatar-img' style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '2px solid var(--blueColor)' }} />
                  :
                  <div className="custom-profile" style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '1px solid #294156' }}>{user?.customer?.first_name[0]?.toUpperCase()}</div>
                }
                <span className='avatar-name'>{user.customer?.first_name} {user.customer?.last_name[0]?.toUpperCase()}</span>
                {dropdownOpen.name === 'profile' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
              </div>
              <div id="dropdown3" className={`dropdown ${dropdownOpen.name === 'profile' && dropdownOpen.open ? 'active' : ''}`} ref={dropdownRef}>
                <ul role="menu ">
                  <li role="menuitem">
                    <NavLink className="dropdown-link" to="/v1/profile/account">Account</NavLink>
                  </li>
                  <li role="menuitem">
                    <NavLink className="dropdown-link" to="/v1/profile/orders">Orders</NavLink>
                  </li>
                  <li role="menuitem">
                    <Link class="dropdown-link" to="/v1/contact?support=Accout Support">Support</Link>
                  </li>
                  <li role="menuitem">
                    <button class="dropdown-link" style={{ color: 'var(--blueColor)' }} onClick={() => setLogOutModal(true)} >Sign Out</button>
                  </li>
                </ul>
              </div>
            </>
              :
              <>
                <button class="btn btn-transparent auth-btn" onClick={() => setSignInModal(true)}>Sign In</button>
                <button class="btn btn-primary auth-btn" onClick={() => setSignUpModal(true)}>Sign Up</button>
              </>
            }
            <Link class="nav-link dropdown-btn cart-btn" to={"/v1/cart"}>
              <i class="fal fa-shopping-cart" aria-hidden="true" style={{ fontSize: '20px', color: '#fff' }}></i>
              {cartData?.items && cartData?.items?.length > 0 && <span>{quantity}</span>}
            </Link>
          </div>

          <button id="hamburger" aria-label="hamburger" aria-haspopup="true" aria-expanded="false"
            onClick={() => {
              setHamburgerOpen(!hamburgerOpen)
            }}
          >
            <i class="bx bx-menu" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </header>
  )
}